







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import User from "../../models/security/user.model";
import GenericEdit from "@/core/Generics/GenericEdit";
import { Component, Vue } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import UserService from "@/services/user.service";
import { CurriculumLevel } from "@/enums/curriculumLevel";
import jsPDF from "jspdf";
import $ from "jquery";
import moment from "moment";
import { Watch } from 'vue-property-decorator/lib/vue-property-decorator';
import UserDocument from '@/models/security/userDocument.model';
import fileService from '@/services/file.service';
@Component({})
export default class Curriculum extends BaseVue {
  userService: UserService = new UserService();
  curriculumLevel = CurriculumLevel;
  isCardModalActive = false;
  loading = false;
  isCertificate = false;
  curriculuUsers: any = {};
  selected = {};
  files = [];
  doc = new jsPDF();
  mounted() {
    this.getUser();
  }
  get user() {
    return this.$store.state.user;
  }

  get userID(){
    return this.$route.params.id
  }
 verDocumento(row: UserDocument) {
    return fileService.download(row.documentId);
  }
  public getYearFromExperiencePeriod(startDate: any, endDate: any) {
    return Math.abs(Math.ceil(moment(endDate).diff(startDate, "year", false)));
  }

  public printCurriculunm() {
    window.print();
    // let iframe: any = this.$refs.iframe;
    // let iframeWindow: any = iframe.contentWindow;
    // let iframeDocument: any = iframeWindow.document;
    // let template: string = (<any>this.$refs.template).innerHTML;
    // iframeDocument.open();
    // iframeDocument.write(template);
    // iframeDocument.close();
    // setTimeout(() => {
    //   iframeWindow.print();
    // }, 500);
  }
  getImage() {
    return `data:image/jpg;base64, ${this.user.profileImage}`;
  }
  @Watch('userID')
  getUser() {
    this.loading = true;
    this.userService
      .getUserWithCVInfoById(parseInt(this.userID))
      .then(user => {
        this.curriculuUsers = user;
           this.files =   user.userDocuments.filter(x => x.document !== null)
          this.selected = this.files[0];
      })
      .finally(() => {
        this.loading = false;
      });

      
  }


  get getProfileImage() {
    if (this.curriculuUsers && this.curriculuUsers.profileImage)
      return `data:image/jpg;base64, ${this.curriculuUsers.profileImage}`;
    return false;
  }
}
